import { makeStyles } from '@mui/styles'
import {
  CHARCOAL,
  GAINSBORO_BORDER,
  LIGHT_GRAY,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

interface Props {
  childrenType: 'table' | 'form'
  isExpanded: boolean
}

const useStyles = makeStyles(() => ({
  container: {
    border: `1px solid ${GAINSBORO_BORDER}`,
    borderRadius: 3,
    marginTop: 10,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 10,
    cursor: 'pointer',
    background: LIGHT_GRAY,
  },
  title: {
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '140%',
    letterSpacing: 0.2,
    color: CHARCOAL,
  },
  childrenContainer: {
    padding: ({ childrenType, isExpanded }: Props) =>
      childrenType === 'form' && isExpanded ? '15px 10px' : 0,
    position: 'relative',
  },
}))

export default useStyles
